/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  mapItem: {
    createdBy: {},
  },
  mapStyles: [],
  error: null,
};

const getters = {
  mapStyles: state => state.mapStyles,
  mapItem: state => state.mapItem,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/maps/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  save({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request = '';
    if (payload.mapItem.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/maps/${payload.mapItem.id}`, payload.mapItem);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/maps`, payload.mapItem);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/maps/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  get_styles({ commit }) {
    return Vue.http.get('http://partner.europark.ee/tiles/styles.json').then((response) => {
      commit(mTypes.GET_MAP_STYLES, response);
    })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, mapItem) {
    state.mapItem = mapItem.data;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.mapItem = {
      name: '',
      style: 'klokantech-basic',
      center: [0, 0],
      zoom: 10,
      zones: [],
    };
  },
  [mTypes.DATA_STORED](state, mapItem) {
    state.mapItem = mapItem.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
  [mTypes.GET_MAP_STYLES](state, styleData) {
    state.mapStyles = styleData.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/maps/map.js